import { render, staticRenderFns } from "./CallToActionEditor.vue?vue&type=template&id=1848a826&"
import script from "./CallToActionEditor.vue?vue&type=script&lang=js&"
export * from "./CallToActionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports